<template>
  <div
    class="author-puzzles"
    v-if="user"
  >
    <h2>
      <router-link
        :to="{
          name: 'user',
          params: {
            userId: authorId
          }
        }"
      >{{ user.name }}</router-link>'s Puzzles
    </h2>

    <pagination
      :resourceUrl="puzzlesUrl"
      :pageSize="$root.defaultPageSize"
      orderBy="date"
      orderType="DESC"
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <puzzle-list :puzzle="item" />
      </template>
    </pagination>
  </div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import PuzzleListItem from '@/components/PuzzleListItem'

import { mapState } from 'vuex'

export default {
  props: {
    authorId: {
      type: [ Number, String ],
      required: true
    }
  },

  components: {
    pagination: Pagination,
    'puzzle-list': PuzzleListItem
  },

  computed: mapState({
    base: state => state.base,
    loaders: state => state.LoaderModule.loaders,
    user: state => state.UserModule.user,

    puzzlesUrl () {
      return this.apiUrl(`/authors/${this.authorId}/puzzles`, true)
    }
  }),

  mounted () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        `UserModule/getUser`, this.authorId
      ).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AuthorPuzzles.vue